import {
    CREATE_CHAT_REQUEST,
    CREATE_CHAT_SUCCESS,
    CREATE_CHAT_FAILURE,
    GET_CHAT_BETWEEN_USERS_REQUEST,
    GET_CHAT_BETWEEN_USERS_SUCCESS,
    GET_CHAT_BETWEEN_USERS_FAILURE,
  } from "./types";
  import { createChat, getChatBetweenUsers } from "services/chatService";
  
  export const createChatAction = (payload) => async (dispatch) => {
    dispatch({ type: CREATE_CHAT_REQUEST });
  
    const result = await createChat(payload);
  
    if (result.success) {
      dispatch({ type: CREATE_CHAT_SUCCESS, payload: result.data });
    } else {
      dispatch({ type: CREATE_CHAT_FAILURE, payload: result.error });
    }
  };
  
  export const getChatBetweenUsersAction = (otherUserId) => async (dispatch) => {
    dispatch({ type: GET_CHAT_BETWEEN_USERS_REQUEST });
  
    try {
      const result = await getChatBetweenUsers(otherUserId);
      if (result.success) {
        dispatch({
          type: GET_CHAT_BETWEEN_USERS_SUCCESS,
          payload: result.data,
        });
      } else {
        dispatch({
          type: GET_CHAT_BETWEEN_USERS_FAILURE,
          payload: result.error,
        });
      }
    } catch (error) {
      dispatch({
        type: GET_CHAT_BETWEEN_USERS_FAILURE,
        payload: error.message || "An error occurred while fetching the chat.",
      });
    }
  };